"use client";

import { Box, Flex } from "@chakra-ui/react";
import { ExternalLink } from "lucide-react";
import { ElementType, FC, ReactElement } from "react";
import { isUrlAbsolute } from "../../utils/url";
import { NavigationItem } from "./types";
import MenuLink from "./MenuLink";

type Props = {
  isInDrawer?: boolean;
  links: NavigationItem[];
  secondaryControls?: ReactElement[];
  // allow consumer to use next/link for example
  linkComponent?: ElementType;
};

const Menu: FC<Props> = ({
  isInDrawer,
  links = [],
  secondaryControls = [],
  linkComponent: LinkComponent = "a",
}) => (
  <Flex
    flexDirection={isInDrawer ? "column" : "row"}
    pt={isInDrawer ? 10 : 0}
    minHeight="100%"
  >
    <Flex
      as="ul"
      flexDirection={isInDrawer ? "column" : "row"}
      flexWrap="wrap"
      justifyContent="center"
    >
      {links.map(({ title, destination }, index) => (
        <Flex
          key={title}
          as="li"
          borderColor="#e2e8f0"
          borderBottomWidth={
            isInDrawer && index < links.length - 1 ? 1 : undefined
          }
        >
          {isUrlAbsolute(destination) ? (
            <MenuLink
              isInDrawer={isInDrawer}
              // @ts-expect-error
              asChild
            >
              <LinkComponent
                href={destination}
                target="_blank"
                rel="noreferrer"
              >
                {title}
                <Box
                  as="span"
                  position="relative"
                  top="-1px"
                  ml={2}
                  color={
                    isInDrawer ? "rgba(0, 0, 0, .4)" : "rgba(255, 255, 255, .6)"
                  }
                >
                  <ExternalLink size="1rem" />
                </Box>
              </LinkComponent>
            </MenuLink>
          ) : (
            <MenuLink
              isInDrawer={isInDrawer}
              // @ts-expect-error
              asChild
            >
              <LinkComponent href={destination}>{title}</LinkComponent>
            </MenuLink>
          )}
        </Flex>
      ))}
    </Flex>

    <Box
      display={isInDrawer ? "flex" : "none"}
      gap={3}
      mt="auto"
      pt={2}
      mb={3}
      flexWrap="wrap"
    >
      {secondaryControls}
    </Box>
  </Flex>
);

export default Menu;
